import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import Page from "../Page/Page";
import Toast from "../../Utils/Toast";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import { Transaction_Forum } from "../../Connections/Transaction";

import "../../Styles/bookInfo.css";
import { Link } from "react-router-dom";

const BookInfo = (props) => {
  const navigator = useNavigate();
  const params = useParams();
  const location = useLocation();
  // ==================================================

  const [book, setBook] = useState({});

  // ==================================================

  useEffect(() => {
    Transaction_Forum.GetOneBookForum(params.id)
      .then((res) => {
        if (res[0]) {
          setBook(res[2].data);
        } else {
          Toast("error", "کتاب پیدا نشد!");
          navigator("/blog");
        }
      })
      .catch((err) => console.log(err));
  }, []);

  // ==================================================

  return (
    <Page>
      <MobileNavBar
        text={book.title}
        action={() => navigator("/hisstori/blog")}
      />
      <div className="BookInfo_wrapper">
        <div
          className="BookInfo_back-arrow mobile-hidden"
          onClick={() => navigator("/hisstori/blog")}
        >
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
              fill="#ffffff"
            />
          </svg>
        </div>
        <img src={book.pic} alt={book.title} />
        <p>
          اینجا میتونید آثار تولید شده توسط کاربرای دیگه برای این کتاب رو
          ببینید, لایکشون کنید و براشون کامنت بزارید.
        </p>
        <div className="BookInfo_actions-list">
          {book?.actions?.map((item, i) => (
            <Link
              key={i}
              to={`/hisstori/blog/${book.bookId}/action`}
              state={{ actionId: item.actionId }}
            >
              <img
                src={item.pic}
                alt={item.bookId}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = `/imgs/Blog/Blog-book-action-poster[${i}].svg`;
                }}
              />
              <p>{item.title}</p>
            </Link>
          ))}
        </div>
      </div>
    </Page>
  );
};

export default BookInfo;
